module.exports = {
  handle: (e, data) => {   
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
          event: 'applicationStepCompleted',
          applicationStepName: data.stepName || 'n/a'
      });          
  }
}